import { render, staticRenderFns } from "./AbyssedRedirects.vue?vue&type=template&id=0b859d38"
import script from "./AbyssedRedirects.vue?vue&type=script&lang=js"
export * from "./AbyssedRedirects.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports